import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export function useInviteToken() {
  const { group } = useAuth();
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!group) {
      setToken(null);
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchOrGenerate = async () => {
      setLoading(true);
      const { data, error } = await supabase.rpc('generate_invite_token', {
        p_group_id: group.id,
      });
      if (!cancelled && !error && data) {
        setToken(data as string);
      }
      if (!cancelled) setLoading(false);
    };

    fetchOrGenerate();

    return () => {
      cancelled = true;
    };
  }, [group?.id]);

  return { token, loading };
}
